module.exports = __webpack_public_path__ + "static/media/sh-forester.9e02ba59.jpg";